import { Theme } from "@material-ui/core";
import palette from "palette";

type ThemeInterface = Exclude<Theme["overrides"], undefined>;

const MuiCheckbox: ThemeInterface["MuiCheckbox"] = {
  root: {
    color: palette.font.body,
    backgroundColor: "inherit",
    "&:hover": {
      backgroundColor: `${palette.font.body}1A`,
    },
    "&$disabled": {
      color: `${palette.disabled} !important`,
      backgroundColor: "transparent !important",
    },
  },
  colorPrimary: {
    "&.Mui-checked:hover, &:hover": {
      backgroundColor: `${palette.primary}1A !important`,
    },
    color: palette.primary,
  },
  colorSecondary: {
    color: palette.secondary,
    "&.Mui-checked:hover, &:hover": {
      backgroundColor: `${palette.secondary}1A !important`,
    },
  },
};

export default MuiCheckbox;
